import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/*
 * @Author: Jhonsem
 * @Date: 2019-03-19 18:40:31
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-03-19 19:02:40
 */
import { getLang, getUUid } from "../utils/apiHelper";
import HttpClient from "../http/index";

var CryptoJS = require("crypto-js");

import { clientError } from "@/api/utils/apiHelper";

var PalmReadClient =
/*#__PURE__*/
function () {
  function PalmReadClient() {
    _classCallCheck(this, PalmReadClient);
  }

  _createClass(PalmReadClient, [{
    key: "printPath",
    //   "https://s3.amazonaws.com/faceanalysis/palm_print/palm_print_zh-cn.json";
    value: function printPath(lang) {
      return "/palm_print/palm_print_reading_".concat(lang, ".json");
    }
  }, {
    key: "shapePath",
    value: function shapePath(lang) {
      return "/palm_shape/palm_shape_".concat(lang, ".json");
    }
  }, {
    key: "facePath",
    value: function facePath(lang) {
      return "https://faceanalysis.s3.amazonaws.com/face_reading/face_reading_".concat(lang, ".json");
    }
    /**
     * 语言类型  :  en,ja,zh-cn,zh  一共4种
     * @param lang
     */

  }, {
    key: "req_palm_print",
    value: function req_palm_print() {
      var _this = this;

      var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var result;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return HttpClient.get(_this.baseUrl + _this.printPath(lang), {});

                case 3:
                  result = _context.sent;
                  console.log("req_palm_print result:", JSON.parse(result.data));
                  resolve(JSON.parse(result.data));
                  _context.next = 12;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](0);
                  reject(_context.t0);
                  clientError("req_palm_print", _context.t0);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 8]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * 语言类型  :  en,ja,zh-cn,zh  一共4种
     * @param lang
     */

  }, {
    key: "req_palm_shape",
    value: function req_palm_shape() {
      var _this2 = this;

      var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var result;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return HttpClient.get(_this2.baseUrl + _this2.shapePath(lang), {});

                case 3:
                  result = _context2.sent;
                  console.log("req_palm_shape result:", JSON.parse(result.data));
                  resolve(JSON.parse(result.data));
                  _context2.next = 12;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](0);
                  reject(_context2.t0);
                  clientError("req_palm_shape", _context2.t0);

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
    /**
     * 语言类型  :  en,ja,zh-cn,zh  一共4种
     * @param lang
     */

  }, {
    key: "req_face_reading",
    value: function req_face_reading() {
      var _this3 = this;

      var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en";
      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var result;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return HttpClient.get(_this3.facePath(lang), {});

                case 3:
                  result = _context3.sent;
                  console.log("face_reading result:", JSON.parse(result.data));
                  resolve(JSON.parse(result.data));
                  _context3.next = 12;
                  break;

                case 8:
                  _context3.prev = 8;
                  _context3.t0 = _context3["catch"](0);
                  reject(_context3.t0);
                  clientError("face_reading", _context3.t0);

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 8]]);
        }));

        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }, {
    key: "deviceId",
    get: function get() {
      return getUUid();
    }
  }, {
    key: "baseUrl",
    get: function get() {
      return "https://cdn.suprestart.com";
    }
  }]);

  return PalmReadClient;
}();

export default new PalmReadClient();